interface V3IconSourcesProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
    size?: number;
    strokeWidth?: string;
}

export const V3IconSources = ({ stroke = "#ABB0BA", size = 16, strokeWidth = "1.5", ...rest }: V3IconSourcesProps) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M4.667 4.667h6.666v4a2 2 0 0 1-2 2H6.667a2 2 0 0 1-2-2v-4ZM6 2v2.667M10 2v2.667M8 10.667V12a1.334 1.334 0 0 0 1.333 1.333h2"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
